export async function toUserMessage(err: unknown): Promise<string> {
  // Timeout/Abort
  if (err instanceof DOMException && err.name === "AbortError")
    return "Máy chủ mất quá lâu để phản hồi";

  

  // NSwag/Fetch kiểu ApiException: { status, response, message, result? }
  const anyErr = err as any;
  if (anyErr?.status) {
    const responseText =
      typeof anyErr.response === "string" ? anyErr.response : undefined;
    if (responseText) {
      try {
        const json = JSON.parse(responseText);
        const fromModelState =
          json?.errors && Object.values(json.errors).flat().join("; ");
        return (
          fromModelState ||
          json?.title ||
          json?.detail ||
          json?.message ||
          responseText ||
          `${anyErr.status}`
        );
      } catch {
        return responseText || `${anyErr.status}`;
      }
    }

    if (anyErr?.result) {
      if (typeof anyErr.result === "string") return anyErr.result;
      if (anyErr.result?.message) return anyErr.result.message;
      if (anyErr.result?.title) return anyErr.result.title;
    }
  }
  
  if (anyErr?.response instanceof Response) {
    try {
      const text = await anyErr.response.text();
      try {
        const json = JSON.parse(text);
        const fromModelState =
          json?.errors && Object.values(json.errors).flat().join("; ");
        return (
          fromModelState ||
          json?.title ||
          json?.detail ||
          json?.message ||
          text ||
          `${anyErr.response.status} ${anyErr.response.statusText}`
        );
      } catch {
        return text || `${anyErr.response.status} ${anyErr.response.statusText}`;
      }
    } catch {
      // fallback
      return anyErr.message || "Lỗi không xác định";
    }
  }

  // Lỗi JS chuẩn
  if (err instanceof Error) return err.message;
  
  // string thuần hoặc kiểu khác
  return typeof err === "string" ? err : String(err);
}
